module.exports = __webpack_public_path__ + "img/rec.be1034be.svg";